<template>
  <el-image v-bind="$attrs" v-on="$listeners">
    <div slot="error" class="cmm-image-error">
      <img src="@cdn?cc20d952f52a" />
    </div>
  </el-image>
</template>

<script>
export default {
  name: 'CmmImage'
}
</script>

<style lang="scss">
.cmm-image-error {
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
}
</style>
